import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { RequestAccess } from '../classes/requestAccess';
import config from '../config.json';

@Injectable({
    providedIn: 'root'
})
export class RequestAccessService {
    API_REQUEST_ACCESS_URL = config.serverAddress + ':' + config.serverPort + '/request-access/';

    constructor(private http: HttpClient) { }

    getAllByIDRequest(idRequest: number | string) {
        return this.http.get<Array<RequestAccess>>(this.API_REQUEST_ACCESS_URL + 'request/' + idRequest);
    }

    /**
     * Traccia un accesso alla pratica identificata dal token di sessione del link.
     * Chi accede (utente loggato o cliente) lo stabilisce il backend: se è presente un JWT valido
     * (aggiunto dall'interceptor) è l'utente, altrimenti il cliente collegato alla pratica.
     */
    create(sessionToken: string) {
        return this.http.post<void>(this.API_REQUEST_ACCESS_URL + 'create', { Token: sessionToken });
    }
}
